import { render, staticRenderFns } from "./GuidedTour.vue?vue&type=template&id=463ead49&"
import script from "./GuidedTour.vue?vue&type=script&lang=js&"
export * from "./GuidedTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports